import { RelationModel } from '../models/relation.model';

class ContactsUtil {
  getHasCustodyFromRelation(profile: RelationModel): null | boolean {
    return profile.hasCustody;
  }
}

export const contactsUtil = new ContactsUtil();
